import { OutTopic } from 'embedded/api/out/OutTopic';
import { AuthenticationStatusChangedMessagePayload } from 'embedded/api/out/messages/AuthenticationStatusChangedMessage';
import { GlueInvoke } from 'app/glue/interop/types';
import { ReloadRequiredMessagePayload } from 'embedded/api/out/messages/ReloadRequiredMessage';
import { LayoutLoadedMessagePayload } from 'embedded/api/out/messages/LayoutLoadedMessage';
import { ReauthenticationRequiredMessagePayload } from 'embedded/api/out/messages/ReauthenticationRequiredMessage';

export interface OutMethodProxy<T> {
    topic: OutTopic;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listener: (invoke: GlueInvoke<T>) => (payload: T) => Promise<any>;
}

const reloadRequired: OutMethodProxy<ReloadRequiredMessagePayload> = {
    topic: 'RELOAD_REQUIRED',
    listener: (invoke) => (payload) => {
        return invoke('IndigoReloadRequired', payload);
    },
};

const reauthenticationRequired: OutMethodProxy<ReauthenticationRequiredMessagePayload> =
    {
        topic: 'REAUTHENTICATION_REQUIRED',
        listener: (invoke) => (payload) => {
            return invoke('IndigoReauthenticationRequired', payload);
        },
    };

const authenticationStatusChanged: OutMethodProxy<AuthenticationStatusChangedMessagePayload> =
    {
        topic: 'AUTHENTICATION_STATUS_CHANGED',
        listener: (invoke) => (payload) => {
            return invoke('IndigoAuthenticationStatusChanged', payload);
        },
    };

const layloadLoaded: OutMethodProxy<LayoutLoadedMessagePayload> = {
    topic: 'LAYOUT_LOADED',
    listener: (invoke) => (payload) => {
        return invoke('IndigoLayoutLoaded', payload);
    },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const outMethods: OutMethodProxy<any>[] = [
    reloadRequired,
    authenticationStatusChanged,
    layloadLoaded,
    reauthenticationRequired,
];
